<script setup lang="ts">
import { ref, provide } from "vue";

interface TabItem {
    index: number;
    heading: string;
    number?: number;
    disabled?: boolean;
    component?: any;
}

const tabs = ref<TabItem[]>([]);
const activeTabIndex = ref(0);

const registerTab = (tab: TabItem) => {
    tab.index = tabs.value.length;
    tabs.value.push(tab);
};

const selectTab = (index: number) => {
    const tab = tabs.value[index];
    if (tab && !tab.disabled) {
        activeTabIndex.value = index;
    }
};

provide("tabset", {
    tabs,
    activeTabIndex,
    registerTab,
    selectTab,
});

defineExpose({ selectTab });
</script>

<template>
    <div class="tabset">
        <ul class="nav nav-tabs" role="tablist">
            <li v-for="(tab, idx) in tabs" :key="tab.index" class="nav-item uib-tab" :class="{ active: activeTabIndex === idx, disabled: tab.disabled }">
                <a
                    href="#"
                    class="nav-link"
                    :class="{ active: activeTabIndex === idx, disabled: tab.disabled }"
                    @click.prevent="!tab.disabled && selectTab(idx)"
                    :aria-selected="activeTabIndex === idx"
                    role="tab"
                >
                    <div v-if="tab.number" class="tab-heading-container">
                        <div class="tab-heading-number-circle">
                            <span class="circle-text">{{ tab.number }}</span>
                            <span class="icon icon-check2"></span>
                        </div>
                        <p class="tab-heading-title">{{ tab.heading }}</p>
                    </div>
                    <div v-else>{{ tab.heading }}</div>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>
